import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
  inject,
  HostListener,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SecondarySideMenuI } from '../../../shared/interfaces/secondary-side-menu.interface';
import { SIDE_MENU_ITEMS } from './constants/side-menu.constant';

@Component({
  selector: 'app-nqf-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl:
    './national-qualifications-framework-descriptors-side-menu.component.html',
  styleUrl:
    './national-qualifications-framework-descriptors-side-menu.component.scss',
})
export class NationalQualificationsFrameworkDescriptorsSideMenuComponent
  implements OnInit
{
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object
  ) {}

  private router = inject(Router);
  public route = inject(ActivatedRoute);
  sideMenuItems = SIDE_MENU_ITEMS;
  isSideMenuOpen = signal<boolean>(false);

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''))
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event & { target: { innerWidth: number } }) {
    this.isSideMenuOpen.update(
      () => event.target?.innerWidth <= 700 && event.target?.innerWidth >= 500
    );
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen.update(
        () =>
          this.document.defaultView!.innerWidth <= 700 &&
          this.document.defaultView!.innerWidth >= 500
      );
    }
  }
}
